import * as _ from 'lodash';

export function formatValueForTransform(val) {
    if (val === null) return 'null';
    if (val === undefined) return '';
    return val;

}

export function convertTransformPropValueToString(val) {
    if (_.isObject(val)) {
        return JSON.stringify(val);
    }
    return (formatValueForTransform(val) || '').toString();
}

